import { access } from '@driftt/traffic-control'

export const {
 hasScopes, hasAnyScope, hasGates, hasAllGates, hasAccess, isAdmin, isAgent, isUser
} = access